/*************************************************************************
 * ADOBE CONFIDENTIAL
 * ___________________
 *
 *  Copyright 2018 Adobe
 *  All Rights Reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Adobe and its suppliers, if any. The intellectual
 * and technical concepts contained herein are proprietary to Adobe
 * and its suppliers and are protected by all applicable intellectual
 * property laws, including trade secret and copyright laws.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Adobe.
 **************************************************************************/
import { inject } from "mobx-react";
import { ScrubberUI } from "components/scrubber/ScrubberUI";
import {
  scrubberPosBasedOnPagesViewPos,
  pagesViewYPosBasedOnScrubberPos,
  getPagesViewXPos
} from "selectors/pagedViewState";
import { getCurrentPageNumber } from "selectors/pageNumber";
import { getTotalPages, isFitOneFullPageMode } from "selectors/documentSelectors";
import { showScrubberMidDiv } from "selectors/pagedViewState";
import { getAdressBarHeight } from "selectors/appUiStateSelectors";
import { injectIntl } from "react-intl";

let lastY = 0;
const mapStoreToProps = (stores, ownProps) => ({
  ...ownProps,
  scrubberYPos: scrubberPosBasedOnPagesViewPos(stores),
  currentPageNumber: getCurrentPageNumber(stores),
  totalPages: getTotalPages(stores),
  showScrubberMidDiv: showScrubberMidDiv(stores),
  addressBarHeight: getAdressBarHeight(stores),
  scrubberEvent: event => {
    const pagesViewYPos = pagesViewYPosBasedOnScrubberPos(stores, event.deltaY - lastY);
    if (isFitOneFullPageMode(stores)) {
      stores.pageByPageStore.setScrollTopAsPerScrubber(pagesViewYPos);
    } else {
      stores.pagedViewState.scrollPagesView(getPagesViewXPos(stores), pagesViewYPos);
    }
    stores.pagedViewState.setShowScrubberMidDiv(true);
    lastY = event.deltaY;
    if (event.isFinal) {
      lastY = 0;
      stores.pagedViewState.setShowScrubberMidDiv(false);
    }
  }
});

const ScrubberContainer = injectIntl(inject(mapStoreToProps)(ScrubberUI));

export { ScrubberContainer };
